import { nsurlsession } from "./nsurlsession/client.mjs";
export const swift = {
    info: {
        key: 'swift',
        title: 'Swift',
        extname: '.swift',
        default: 'nsurlsession',
    },
    clientsById: {
        nsurlsession,
    },
};
